



















































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';
import {Inject} from 'inversify-props';

import {ISystemCertificateService} from '@/services/system/ICertificate.service';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class CertificateUpload extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ISystemCertificateService'))
  private systemCertificateService!: ISystemCertificateService;

  private certificateFileInput: File | null = null;

  private keyFileInput: File | null = null;

  private uploading: boolean = false;

  private fileFilter: any = {
    type: String,
    default: '*',
  };

  private uploadRulesCertificate = [
    (value: string) => !!value[0] || 'required',
  ];

  private uploadRulesKey = [
    (value: string) => !!value[0] || 'required',
  ];

  private uploadFormValid: boolean = true;

  private async uploadCertificate() {

    const uploadForm = this.$refs.uploadForm as Vue & { validate: () => boolean };

    if (uploadForm.validate()) {
      try {
        this.uploading = true;
        const newCertificate = await this.systemCertificateService.upload(this.certificateFileInput, this.keyFileInput);
        this.logger.info('New certificate uploaded', newCertificate);
        Notify.Success(this.logger, `The certificate has been uploaded<br>Restart the Manager daemon to use the new certificate`);
        this.$emit('update:certificate', newCertificate);
      } catch (error) {
        Notify.Error(this.logger, `Could not upload the certificate`, error);
      } finally {
        this.uploading = false;
      }
    }
  }
}
